import React, { Component } from 'react'

// ui
import Modal from '../../components/feedback/modal'
import Button from '../../components/uielements/button'

// redux
import { connect } from 'react-redux'
import eventActions from '../../redux/event/actions'
import ContentCreateEvent from './Content_create_event'
class CreateNewEvent extends Component {
    _handleOK = () => {
        this.props.dismiss()
    }

    _handleCancel = () => {
        this.props.dismiss()
    }

    render() {
        const { visible } = this.props
        return (
            <div>
                {visible && (
                    <Modal
                        visible={true}
                        onOk={() => this._handleOK()}
                        onCancel={() => this._handleCancel()}
                        width={window.innerWidth / 2}
                        height={1000}
                        centered={false}
                        footer={[]}
                    >
                        <ContentCreateEvent />
                    </Modal>
                )}
            </div>
        )
    }
}

const mapStateToProps = state => {
    return {
        user: state.user.currentUser,
        visible: state.eventReducer.visibleCreateModal,
    }
}

const mapDispatchToProps = dispatch => {
    return {
        dismiss: () => {
            dispatch(eventActions.action.visibleCreateModal(false))
        },
    }
}

export default connect(
    mapStateToProps,
    mapDispatchToProps
)(CreateNewEvent)
